import { DateAsIsoString } from "./formikData";

export interface IQuoteIllustrationDto {
  id: number;
  number: string | null;
  productId: number;
  productName: string;
  productVariantId: number | null;
  productVariantName: string | null;
  premiumMode: IllustrationPremiumMode;
  productCode: IllustrationProduct;
  language: string;
  generateIllustration: boolean;
  coverages: ICoverageIllustrationDto[];
  insureds: IInsuredIllustrationDto[];
  advisorCode?: string | null;
  advisorFirstName?: string | null;
  advisorLastName?: string | null;
  systemDate?: string | null;
}

export interface ICoverageIllustrationDto extends IllustrationRatingInfo {
  id: string;
  planId: string;
  planName: string;
  lifeIds: string[];
  faceAmount: number | null;
  isBasePlan: boolean;
  expiryAge: string | undefined;
  productCode: string;
  permTableRating?: string | null;
}

export interface IInsuredIllustrationDto extends IllustrationRatingInfo {
  id: string;
  backDateAge: boolean | undefined | null;
  gender: IllustrationGender;
  dateOfBirth: DateAsIsoString | undefined | null;
  firstName: string | undefined | null;
  lastName: string | undefined | null;
  isSmoker: boolean;
  age: number;
}

export interface IllustrationRatingInfo {
  permTableRating?: string | null;
  permFlatExtraAmt?: number | null;
  tempFlatExtraAmt?: number | null;
  tempFlatExtraDuration?: number | null;
}

export interface ICriticalIllnessIllustrationDto {
  id: number;
  premiumTypeId: number;
  expiryAge: number;
}

export interface IPayorDisabilityWaiverIllustrationDto {
  id: number;
  age: number | null;
  isSmoker: boolean | null;
  useBackDate: boolean;
}

export type PremiumValueLabel = {
  value: string | undefined;
  label: string;
}

export enum IllustrationProduct {
  Term = "Term",
  CriticalIllness = "CI"
}

export enum IllustrationGender {
  Male = "male",
  Female = "female"
}

export enum IllustrationPremiumMode {
  Annual = "Annual",
  Monthly = "Monthly"
}

export enum IllustrationLanguageCode {
  LanguageCode = "-CA"
}

export interface IllustrationData {
  coverages: IllustrationCoverage[];
  insureds: IllustrationInsured[];
  productCode: IllustrationProduct;
  annualPremium: number;
  annualPolicyFee: number;
  monthlyPremium: number;
  monthlyPolicyFee: number;
  premiumMode: IllustrationPremiumMode;
  salesIllustration: string | null;
  documentId: string | null;
  advisorCode: string | null;
}

export interface IllustrationCoverage {
  id: string;
  planId: string;
  lifeIds: string[];
  faceAmount: number;
  isBasePlan: boolean;
  usePreferredTermRates: boolean | null;
  annualPremium: number;
  monthlyPremium: number;
  expiryAge: number | null;
  smokerQuestionAgeNearest: number;
  productCode: IllustrationProduct;
}

export interface IllustrationInsured {
  id: string;
  backDateAge: boolean;
  gender: IllustrationGender;
  dateOfBirth: DateAsIsoString | undefined | null;
  firstName: string | undefined | null;
  lastName: string | undefined | null;
  isSmoker: boolean;
  age: number;
}

